// WO-60 — the "Latest check" note on a project or company page.
// Written by ANTHONY (AI) from public sources; labelled as AI research (EU AI Act
// art. 50) and every source is shown as a clickable link (OpenAI's web-search terms).
import React from 'react';
import { Sparkles, ExternalLink } from 'lucide-react';
import { safeUrl } from '../lib/safeUrl';

const fmtDate = (iso, ar) => {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString(ar ? 'ar' : 'en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
};

const hostOf = (url) => {
  try { return new URL(url).hostname.replace(/^www\./, ''); } catch (e) { return url; }
};

export default function ResearchNote({ item, language }) {
  const note = item && item.research_public;
  if (!note || !note.text) return null;
  const ar = language === 'ar';
  const sources = (note.sources || []).filter((s) => s && safeUrl(s.url));
  return (
    <div className="rounded-lg border border-primary/20 bg-primary/5 p-3 space-y-1" data-testid="research-note" dir={ar ? 'rtl' : 'ltr'}>
      <p className="flex items-center gap-2 text-xs font-medium text-primary">
        <Sparkles className="w-3.5 h-3.5" />
        {ar ? 'آخر تحقق — بحث بالذكاء الاصطناعي' : 'Latest check — AI research'}
        {note.checked_at && <span className="text-muted-foreground font-normal">· {fmtDate(note.checked_at, ar)}</span>}
      </p>
      <p className="text-sm leading-relaxed" dir="ltr">{note.text}</p>
      {sources.length > 0 && (
        <p className="flex flex-wrap gap-x-3 gap-y-1 text-xs">
          <span className="text-muted-foreground">{ar ? 'المصادر:' : 'Sources:'}</span>
          {sources.map((s) => (
            <a key={s.url} href={safeUrl(s.url)} target="_blank" rel="noopener noreferrer nofollow"
               className="inline-flex items-center gap-1 text-primary hover:underline">
              {hostOf(s.url)}<ExternalLink className="w-3 h-3" />
            </a>
          ))}
        </p>
      )}
    </div>
  );
}
